import { Component, inject, Input, OnInit } from '@angular/core';
import { StatefulService } from '@app/service/stateful.service';
import { Info } from '@workflow/ecp-shared/constant/information.const';
import { CustomFields } from '@workflow/ecp-workflow/dynamic-app/types/dynamic-custom-fields.type';

/**
 * different type of field layout
 */
@Component({
  selector: 'ecp-additional-ques-review',
  templateUrl: './oao-additional-ques-review.component.html',
  standalone: false
})
export class OaoAdditionalQuesReviewComponent implements OnInit {
  private readonly statefulService = inject(StatefulService);

  /** Application Custom Field Declaration */
  public applicationCustomFields: CustomFields[];
  /** Array Path */
  private valuepath = 'customField/applicationCustomFields/$/fieldValue';
  private labelpath = 'customField/applicationCustomFields/$/fieldLabel';

  @Input()
  public cardId: string;

  private get isOla() {
    // eslint-disable-next-line eqeqeq
    return this.cardId == 'ola-additional-question';
  }

  constructor() {}

  /** Init */
  public ngOnInit(): void {
    this.applicationCustomFields = [];
    this.displayAdditionalQues();
  }
  private displayAdditionalQues() {
    let pathPrefix = 'api:oaoMemberInformation/';
    if (this.isOla) {
      pathPrefix = 'ola:olaApplicationInformation/';
    }
    const customFieldPath = `${pathPrefix}customField/applicationCustomFields`;
    const customFieldSize = this.statefulService.arraySize(customFieldPath);
    if (customFieldSize > 0) {
      for (let index = 0; index < customFieldSize; index++) {
        const fieldLabelValue = this.statefulService.wrap(`${pathPrefix}${this.labelpath}`, index).valueString;
        // Since we have initialized 20 items into the bundle during creation and
        // there's a possibility of race condition with bundle data not yet being updated with the API response
        // Added a null check for field label or question value so that only field labels having actual values show up on the Review screen
        // Not adding a check for field value because they can be configured to be optional as well
        if (this.doesFieldLabelHasValue(fieldLabelValue)) {
          const customField = {
            fieldLabel: this.statefulService.wrap(`${pathPrefix}${this.labelpath}`, index).value,
            fieldValue: this.statefulService.wrap(`${pathPrefix}${this.valuepath}`, index).value
          } as CustomFields;

          this.applicationCustomFields.push(customField);
        }
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public displayValue(value: any) {
    if (!value) {
      return Info.optionalReviewFieldText;
      // eslint-disable-next-line eqeqeq
    } else if (value == 'true') {
      return 'Yes';
      // eslint-disable-next-line eqeqeq
    } else if (value == 'false') {
      return 'No';
    }
    return value;
  }

  doesFieldLabelHasValue(fieldLabelValue: string): boolean {
    return fieldLabelValue ? true : false;
  }
}
